import { useEffect } from 'react';
import { Container, Row, Col } from "react-bootstrap";
import SingleScrip from './SingleScrip';
import EquitySip from './EquitySip';
import { useDispatch } from 'react-redux';
import { clearAllOpenOrders, getAllGtdOrders, getAllMultiScripOrders, getAllOpenOrders, getAllSipOrders, getAllSpreadOrders, getScripOrderInfo } from '../../../../../redux/actions/orders';
import MultiLeg from './MultiLeg';
import Spread from './Spread';
import GoodTillDate from './GoodTillDate';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import { IS_MULTILEG_ALLOWED, MARKET_SEGMENT_ID, ORDER_TYPES, ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API } from '../../../../../utils/global_variables';

const isHistoryAllowed = false

const OrdersContents = ({ ordersActiveTabKey }) => {

    const dispatch = useDispatch();

    // Vinit Raut : 15-03-2024 : BT-127175 - Breeze – Bug fixes -- Start 
    useEffect(() => {
        dispatch(getAllOpenOrders({ offSet: 1, limit: 20, orderType: [{ orderType: 'spread', offSet: 1, limit: 20, orderStatus: -1 }, { orderType: 'multileg', offSet: 1, limit: 20, orderStatus: -1 }], orderStatus: -1 }));
        dispatch(getAllSpreadOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
        dispatch(getAllMultiScripOrders({ offSet: 1, limit: 20, multileg: true, orderStatus: -1 }));
        dispatch(getAllGtdOrders({ offSet: 1, limit: 20, orderStatus: -1 }));
        dispatch(getAllSipOrders({ offSet: 1, limit: 100, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }, isHistoryAllowed));

        return () => dispatch(clearAllOpenOrders());
    }, [dispatch]);
    // Vinit Raut : 15-03-2024 : BT-127175 - Breeze – Bug fixes -- End

    // TODO: Remove
    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- Start 
    // useEffect(() => {
    //     // dispatch(clearAllOpenOrders()); //  Vinit R : 21-02-2024 : NSE FAO Watchlist Sidetray - Orders, Positions and Holdings
    //     if (ordersActiveTabKey === 'single_scrip') {
    //         dispatch(getAllOpenOrders({ offSet: 1, limit: 20, orderType: [{ orderType: 'spread', offSet: 1, limit: 20, orderStatus: -1 }, { orderType: 'multileg', offSet: 1, limit: 20, orderStatus: -1 }], orderStatus: -1 }));
    //         dispatch(updateModalData({}));
    //     } else if (ordersActiveTabKey === 'spread') {
    //         dispatch(getAllMultiScripOrders({ offSet: 1, limit: 20, spread: true, orderStatus: -1 }));
    //         dispatch(updateModalData({}));
    //     } else if (ordersActiveTabKey === 'multi_Leg') {
    //         dispatch(getAllMultiScripOrders({ offSet: 1, limit: 20, multileg: true, orderStatus: -1 }));
    //         dispatch(updateModalData({}));
    //     } else if (ordersActiveTabKey === 'good_till_date') {
    //         dispatch(getAllGtdOrders({ offSet: 1, limit: 20, orderStatus: -1 }));
    //         dispatch(updateModalData({}));
    //     } else if (ordersActiveTabKey === 'equity_sip') {
    //         // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---Start           
    //         dispatch(getAllSipOrders({ offSet: 1, limit: 100 }));
    //         // Azeem K : 28-11-2023 :BT-107418 :Breeze - Order Book - SIP Order  ---End           
    //         dispatch(updateModalData({}));
    //     }
    // return () => dispatch(clearAllOpenOrders())
    // }, [ordersActiveTabKey]);
    // Vinit Raut : 23-02-2024 : BT-127175 - Breeze – Bug fixes -- End

    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -start
    const handlePlaceOrder = () => {
        dispatch(handleModal([{ "ORDER_ENTRY_MODAL": true }]));
        dispatch(handleModalData({ data: { orderEntryTab: ORDER_TYPES.SINGLE_SCRIP } }));
        const objScrpinfo = { activeExchangeId: MARKET_SEGMENT_ID.NSE_CASH, isBuySell: 0, scripData: [] };
        dispatch(getScripOrderInfo(objScrpinfo));
    };
    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -end

    return (
        <Container fluid className='p-0'>
            <Row className='g-0'>
                <Col>
                    {
                        ordersActiveTabKey === 'single_scrip' &&
                        <SingleScrip handlePlaceOrder={handlePlaceOrder} />
                    } 
                    {
                        ordersActiveTabKey === 'spread' &&
                        <Spread handlePlaceOrder={handlePlaceOrder} />
                    }  {
                        IS_MULTILEG_ALLOWED && ordersActiveTabKey === 'multi_Leg' &&
                        <MultiLeg handlePlaceOrder={handlePlaceOrder} />
                    }  {
                        ordersActiveTabKey === 'good_till_date' &&
                        <GoodTillDate handlePlaceOrder={handlePlaceOrder} />
                    }  {
                        ordersActiveTabKey === 'equity_sip' &&
                        <EquitySip handlePlaceOrder={handlePlaceOrder} />
                    }

                </Col>
            </Row>
        </Container>

    );
};

export default OrdersContents;